import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_USERS_IN_BUSINESS: (businessId) => ({ businessId }),
    API: {
      GET_USERS_IN_BUSINESS: apiResourceActionCreator('usersInBusiness')
    }
  }
})

export const apiAction = (authToken, businessId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getUsersInBusiness/${businessId}`, authToken, action.admin.api.getUsersInBusiness)

function* getUsersInBusiness(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.businessId));
}

const configuration = {
  name: 'getUsersInBusiness',
  action: action,
  sagas: getUsersInBusiness,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingUsersInBusiness: true
    }),
    success: (state, action) => {
      return ({
        ...state,
        isFetchingUsersInBusiness: false,
        usersInBusiness: action.payload.usersInBusiness
      })
    },
    failed: (state, action) => ({
      ...state,
      isFetchingUsersInBusiness: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getUsersInBusiness.js